import React from 'react';

import { LoadingTile, Tile } from '@sm360/widget-tile-a';

const LoadableTileA = (props) => {
    return <Tile {...props} />;
};

LoadableTileA.displayName = 'LoadableTileA';

export { LoadingTile };

export default LoadableTileA;



// WEBPACK FOOTER //
// /builds/development/frontend/widgets/widgets/components/tiles/themed-tile/src/components/TileA/TileA.jsx